import _ from "lodash"

// test: jest src/models/__tests__/MenuItem.model.spec.js
export default class MenuItem {
  constructor(rawData) {
    this._rawData = rawData;
  }

  get iconPosition() {
    const configuredValue = _.get(this._rawData, 'icon_position')
    const allowedValue = ['left', 'right']
    const defaultValue = 'left'
    return allowedValue.includes(configuredValue) ? configuredValue : defaultValue
  }
}
